import script from "./SynonymsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SynonymsPage.vue?vue&type=script&setup=true&lang=js"

import "./SynonymsPage.vue?vue&type=style&index=0&id=0f6b5dd8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6b5dd8"]])

export default __exports__